import { createFileRoute } from "@tanstack/react-router";
import FeedSettings from "@/pages/admin/FeedSettings";

export const Route = createFileRoute("/admin/feed")({
  component: FeedSettings,
});
